import ZOption from '../select/option.vue'

ZOption.install = function(app) {
  app.component(ZOption.name, ZOption)
}

export default ZOption